<div
  class="multi-select-grouped"
  [class.multi-select-grouped--filtro]="variante === 'filtro'"
  [class.multi-select-grouped--has-value]="selectedTotalOptions > 0"
  [class.multi-select-grouped--open]="isOpen"
>
  <div
    class="multi-select-grouped__input"
    #inputRef
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="!disabled && open()"
  >
    <ng-content select="[input-prefix]"></ng-content>

    <span class="multi-select-grouped__input-icon" *ngIf="exibirIcone" aria-hidden="true">
      <i class="fas" [ngClass]="icon"></i>
    </span>

    <input
      type="text"
      readonly
      [placeholder]="customPlaceholder || settings?.placeholder"
      [disabled]="disabled"
    />

    <ng-container *ngIf="settings?.showCountSelected">
      <span
        class="multi-select-grouped__clear"
        [class.multi-select-grouped__clear--disabled]="disabled"
        *ngIf="selectedTotalOptions > 0"
      >
        <span class="badge badge-primary badge-pill">
          {{ selectedTotalOptions }}
          <i
            class="fas fa-times"
            (click)="!disabled && close(); $event.stopPropagation()"
          ></i>
        </span>
      </span>
    </ng-container>

    <span class="multi-select-grouped__input-indicator">
      <i
        class="fas"
        [ngClass]="{
          'fa-chevron-up': isOpen,
          'fa-chevron-down': !isOpen
        }"
      ></i>
    </span>
  </div>

</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  [cdkConnectedOverlayPanelClass]="overlayPanelClasses"
  (overlayOutsideClick)="onOverlayOutsideClick($event)"
  (detach)="onOverlayDetach()"
>
  <div
    class="multi-select-grouped__dropdown"
    [class.multi-select-grouped__dropdown--com-rodape]="settings.showFooter !== false"
    [style.--largura-do-trigger.px]="larguraDoTrigger"
    [style.--altura-maxima-dropdown.px]="overlayMaxHeight"
  >
    <ng-container *ngIf="!settings?.isLoading">
      <div class="multi-select-grouped__filter">
        <i class="fas fa-search multi-select-grouped__filter-icon"></i>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearch()"
          placeholder="Pesquisar..."
        />
        <button
          *ngIf="searchText"
          type="button"
          (click)="clearSearchInput($event)"
          class="multi-select-grouped__filter-clear"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="multi-select-grouped__actions">
        <ng-content select="[actions]"></ng-content>
      </div>

      <ul
        class="multi-select-grouped__options multi-select-grouped__options--cabecalho"
        *ngIf="filteredOptions.length > 0"
      >
        <li (click)="selectAllOptions($event)">
          <div
            class="multi-select-grouped__select-all"
          >
            <input
              class="multi-select-grouped__checkbox"
              type="checkbox"
              [checked]="todasVisiveisSelecionadas"
              [indeterminate]="selecaoVisivelParcial"
              tabindex="-1"
            />
            <span class="multi-select-grouped__option-label">{{ selectAllLabel }}</span>
            <span class="multi-select-grouped__select-all-count">
              {{ selectedVisibleOptions }}/{{ totalVisibleOptions }}
            </span>
          </div>
        </li>
      </ul>

      <ul class="multi-select-grouped__options" #optionsList>
        <ng-container *ngIf="filteredOptions.length > 0; else noOptions">
          <li *ngFor="let group of filteredOptions">
            <strong>{{ group.name | uppercase }}</strong>
            <div
              *ngFor="let option of group.options"
              title="{{ option.name }}"
              (click)="selectOption(option)"
            >
              <input
                class="multi-select-grouped__checkbox"
                type="checkbox"
                [checked]="option.isChecked"
                (change)="$event.stopPropagation()"
              />
              <i
                *ngIf="option.icon"
                class="multi-select-grouped__option-icon"
                [ngClass]="option.icon"
                aria-hidden="true"
              ></i>
              <span class="multi-select-grouped__option-label">
                {{ preserveCase ? option.name : (option.name | uppercase) }}
              </span>
              <span
                class="multi-select-grouped__option-count"
                *ngIf="option.count !== undefined"
              >
                {{ option.count }}
              </span>
            </div>
        </li>
      </ng-container>

      <ng-template #noOptions>
        <div class="multi-select-grouped__options--empty">
          <span>{{ settings?.searchEmptyResultMessage }}</span>
        </div>
      </ng-template>
    </ul>
    </ng-container>

    <div class="multi-select-grouped__loading" *ngIf="settings?.isLoading">
      <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
      <span>Carregando...</span>
    </div>

    <div
      *ngIf="settings.showFooter !== false"
      class="multi-select-grouped__footer"
    >
      <button
        class="btn btn-outline-secondary"
        [disabled]="semDados"
        (click)="close()"
      >
        Limpar
      </button>
      <button
        class="btn btn-primary"
        [disabled]="semDados"
        (click)="searchOptions()"
      >
        Filtrar
      </button>
    </div>
  </div>
</ng-template>
